import { DATA_METRICS } from '../componentKeys.js'

const identifiers = {
  key: 'contacted',
  type: 'call',
  access: 'stats',
}

const formatting = {
  format: {
    title: 'Contacted',
  },
}

const keys = {
  statKey: 'contacted',
  componentKeys: [DATA_METRICS],
  healthKey: 'metric_health',
}

const calculation = {
  calcType: 'aggregate',
}

const contacted = {
  metaData: Object.assign(identifiers, formatting, keys, calculation),
  calculationConfig: calculation,
}

export { contacted }
